/**
 * Floating switcher between the full desktop editor and the lite mobile editor.
 *
 * Shows only on phone-sized screens while inside the desktop app (the dense
 * desktop editor is hard to use on a phone), offering a one-tap jump to the
 * touch-first mobile editor. The mobile editor surfaces its own "open full
 * editor" affordances, so this is intentionally one-directional.
 */
import { useLocation, useNavigate } from 'react-router-dom';
import { Smartphone } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

export default function EditorPlatformSwitcher() {
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const path = location.pathname;
  const inMobile = path === '/m' || path.startsWith('/m/');
  const inEditor = path === '/editor' || path.startsWith('/editor/');
  const inDashboard = path === '/dashboard';

  if (!isMobile || inMobile || (!inEditor && !inDashboard)) return null;

  const editorMatch = path.match(/^\/editor\/([^/]+)/);
  const target = editorMatch ? `/m/${editorMatch[1]}` : '/m';

  return (
    <button
      onClick={() => navigate(target)}
      className="fixed bottom-4 left-1/2 z-[60] flex -translate-x-1/2 items-center gap-2 rounded-full bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white shadow-lg shadow-indigo-600/30 active:bg-indigo-700"
      style={{ marginBottom: 'env(safe-area-inset-bottom)' }}
    >
      <Smartphone className="h-4 w-4" />
      Switch to mobile editor
    </button>
  );
}
